import React, { useEffect } from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { WebPortalDashboardInitialData } from 'app/types/dataInterfaces';
import { createCurrentPositionMarker, createCurrentPositionPopUp, createCurrentPositionMultiPopUp, createMap, groupByConsolId } from './mapUtils';
import { IMapSettingsModel } from 'app/components/MapSettings/MapSettingsModel';
import { CargoMode } from "app/types/enums";

type DashboardMapProps = {
    dashboardData: WebPortalDashboardInitialData[] | undefined;
    mapSettings: IMapSettingsModel[] | undefined;
}

const DashboardMap = ({ dashboardData, mapSettings }: DashboardMapProps) => {
    useEffect(() => {
        const map = createMap();
        const bookingData = dashboardData?.filter((value) => value.bookingTypeID === 18 && value.longitude != null && value.latitude != null);

        if (bookingData && bookingData.length > 0) {
            var groupByConsol = groupByConsolId(bookingData);
            for (const consolId in groupByConsol) {
                if (groupByConsol.hasOwnProperty(consolId)) {
                    if (consolId !== '0') {
                        var consol = groupByConsol[consolId].filter((booking) => { return isDisplayCurrentPosition(booking) });
                        if (consol && consol.length > 0) {
                            var favouriteBooking = consol.filter((booking) => { return booking.isFavourite === true });
                            if (favouriteBooking && favouriteBooking.length > 0) {
                                consol.sort((a, b) => b.isFavourite === true ? 1 : -1);
                                var currentPosition = L.circleMarker([favouriteBooking[0].latitude, favouriteBooking[0].longitude], createCurrentPositionMarker(favouriteBooking[0])).addTo(map);
                                currentPosition.bindPopup(createMultiPopup(consol, favouriteBooking[0])).bindTooltip(createToolTip(favouriteBooking[0], consol.length));
                            }
                            else {
                                var currentPosition = L.circleMarker([consol[0].latitude, consol[0].longitude], createCurrentPositionMarker(consol[0])).addTo(map);
                                currentPosition.bindPopup(createMultiPopup(consol, consol[0])).bindTooltip(createToolTip(consol[0], consol.length));
                            }
                        }
                    }
                    else {
                        groupByConsol[consolId].forEach(booking => {
                            if (isDisplayCurrentPosition(booking)) {
                                var currentPosition = L.circleMarker([booking.latitude, booking.longitude], createCurrentPositionMarker(booking)).addTo(map);
                                currentPosition.bindPopup(createPopup(booking)).bindTooltip(createToolTip(booking, "1"));
                            }
                        });
                    }
                }
            }

            if (bookingData) {
                const points: [number, number][] = bookingData.map(m => [m.latitude, m.longitude])
                const bounds = L.latLngBounds(points);
                map.fitBounds(bounds, { paddingBottomRight: [340, 0], paddingTopLeft: [100, 0], maxZoom: 3 });
            }
        }
        return () => { map.remove() };
    }, [dashboardData, mapSettings])

    const isDisplayCurrentPosition = (bookingDetail) => {
        if (mapSettings && mapSettings.length > 0) {
            if (bookingDetail.cargoMode === CargoMode.LCL) {
                return mapSettings[0].isDisplay;
            }
            if (bookingDetail.cargoMode === CargoMode.FCL) {
                return mapSettings[1].isDisplay;
            }
        }
        return true;
    }

    const createToolTip = (booking, bookingCount) => {
        return L.tooltip()
            .setLatLng([booking.latitude, booking.longitude])
            .setContent(`${bookingCount}`);
    }

    const createPopup = (booking) => {
        return L.popup({ minWidth: 220, maxHeight: 150, keepInView: true })
            .setLatLng([booking.latitude, booking.longitude])
            .setContent(createCurrentPositionPopUp(booking));
    }

    const createMultiPopup = (consol, booking) => {
        return L.popup({ minWidth: 220, maxHeight: 150, keepInView: true })
            .setLatLng([booking.latitude, booking.longitude])
            .setContent(createCurrentPositionMultiPopUp(consol));
    }

    return (
        <>
            <div id="map" style={{ position: 'relative', zIndex: '0' }} ></div>
        </>
    );
}

export default DashboardMap;

